<template>
  <div class="p-4 flex justify-between items-center">
    <div class="h-8">
      <img
        :src="`${imageProxyUrl}rs:fill:160:37:0/plain/${logo}`"
        :alt="trans.get('miliboo.common.brand')"
        width="160"
        height="37"
        class="w-[120px] font-medium text-4xl lowercase"
      >
    </div>
    <button
      type="button"
      class="-m-2 p-2 inline-flex items-center justify-center text-gray-700"
      @click="setOpen(false)"
    >
      <span class="sr-only">{{ trans.get('miliboo.common.close') }}</span>
      <v-icon-x class="h-6 w-6" />
    </button>
  </div>
</template>
<script setup>

import { inject } from 'vue';

defineProps({
  setOpen: {
    type: Function,
    required: true,
  },
  logo: {
    type: String,
    required: true,
  },
  imageProxyUrl: {
    type: String,
    required: true,
  },
});

const trans = inject('translate');

</script>
